import { getRuntimeConfig, type SystemEnvironment } from '@berky/auth'
import {
  StatusBadge,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@berky/ui'
import { CircleCheck, FlaskConical, Laptop } from 'lucide-react'

const presentations = {
  local: {
    label: 'LOKALE TESTINSTANZ',
    shortLabel: 'LOKAL',
    description:
      'Sie arbeiten in einer lokalen Testinstanz. Änderungen betreffen ausschließlich lokale Entwicklungsdaten.',
    tone: 'info',
    icon: Laptop,
  },
  test: {
    label: 'TESTSYSTEM',
    shortLabel: 'TEST',
    description:
      'Sie arbeiten im Testsystem. Änderungen betreffen ausschließlich Testdaten.',
    tone: 'warning',
    icon: FlaskConical,
  },
  production: {
    label: 'ECHTSYSTEM',
    shortLabel: 'ECHT',
    description: 'Sie arbeiten im Echtsystem. Änderungen betreffen Echtdaten.',
    tone: 'success',
    icon: CircleCheck,
  },
} as const

export function SystemEnvironmentBadge({
  environment = getRuntimeConfig().systemEnvironment,
}: {
  environment?: SystemEnvironment
}) {
  const presentation = presentations[environment]
  const Icon = presentation.icon

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <StatusBadge
            tone={presentation.tone}
            tabIndex={0}
            aria-label={`Systemumgebung: ${presentation.label}`}
            className="cursor-help tracking-wide"
          >
            <Icon className="size-3" aria-hidden="true" />
            <span className="hidden sm:inline">{presentation.label}</span>
            <span className="sm:hidden">{presentation.shortLabel}</span>
          </StatusBadge>
        </TooltipTrigger>
        <TooltipContent>{presentation.description}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
